import {ReactComponent as IconArrowUpRight} from "assets/icons/arrow-up-right.svg";
import {ReactComponent as IconChevron} from "assets/icons/chevron.svg";
import {ReactComponent as IconLike} from "assets/icons/like.svg";
import {ReactComponent as IconPlay} from "assets/icons/play.svg";
import {ReactComponent as IconSocial} from "assets/icons/social.svg";
import {ReactComponent as IconEmail} from "assets/icons/email.svg";
import {ReactComponent as IconArrow} from "assets/icons/arrow.svg";

const icons = {
    IconArrowUpRight,
    IconChevron,
    IconLike,
    IconPlay,
    IconSocial,
    IconEmail,
    IconArrow,
}

export default icons;

export type IconsType = keyof typeof icons;